import { useModel as _useModel, defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["onClick"]

import router from "@/router"
  import {onBeforeMount} from "vue"

  
export default /*@__PURE__*/_defineComponent({
  __name: 'breadcrumb',
  props: {
    "links": {
    default: [],
    required: false,
    type: Array<{
      title: string,
      routeName: string
    }>
  },
    "linksModifiers": {},
    "title": {
    default: null,
    required: false,
    type: String
  },
    "titleModifiers": {},
  },
  emits: ["update:links", "update:title"],
  setup(__props) {

  const links = _useModel(__props, "links")

  const title = _useModel(__props, "title")

  onBeforeMount(() => {
    setCurrentRouteTitle()
  })
  
  function setCurrentRouteTitle() {
    if (title.value != null) {
      return
    }
    try {
      title.value = router.currentRoute.value.meta.title.toString()
    } catch (error) {
      console.error(error)
    }
  }
  
  function routeRedirect(routeName: string) {
    router.push({
      name: routeName
    })
  }

return (_ctx: any,_cache: any) => {
  const _component_scoped = _resolveComponent("scoped")!

  return (_openBlock(), _createBlock(_component_scoped, null, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(links.value, (link) => {
          return (_openBlock(), _createElementBlock("span", {
            key: link.title,
            onClick: ($event: any) => (routeRedirect(link.routeName))
          }, _toDisplayString(link.title ? link.title : link.routeName) + " / ", 9, _hoisted_1))
        }), 128)),
        _createElementVNode("span", null, _toDisplayString(title.value), 1)
      ])
    ]),
    _: 1
  }))
}
}

})